<template>

    <v-card color="grey lighten-4" class="kim-card" height="280">
     <v-card-text>
       <v-layout  wrap justify-center align-center>

         <v-flex xs12 text-xs-center>
           <v-avatar size="100" color="primary">
             <v-icon size="50" color="white">
               fa-calendar-alt
             </v-icon>
           </v-avatar>
         </v-flex>

         <v-flex xs12>
           <v-divider class="my-2"></v-divider>
         </v-flex>

         <v-flex xs12 text-xs-center>
           <div class="text-xs-center mx-auto">
             <div class="headline">Total de citas</div>
             <div class="subheading">a la fecha</div>
             <div class="display-3">
                 {{ total }}
             </div>
           </div>
         </v-flex>
       </v-layout>
     </v-card-text>
    </v-card>

</template>

<script>
export default {
  name: "AppointmentsCounter",
  props:{
    total: {
      type: Number,
      default: 0
    }
  },
}
</script>

<style scoped>

</style>